// extracted by mini-css-extract-plugin
export default {"ChangesSavedToast__Image":"ChangesSavedToast-styles__ChangesSavedToast__Image__EJb0M"};